// extracted by mini-css-extract-plugin
module.exports = {"recipientsBox":"createSuppression__recipientsBox___3y83l"};